export const SOW_USAGE_CSV_MAX_BYTES = 1024 * 1024;

export const SOW_USAGE_CSV_REQUIRED_HEADERS = [
    'usageId',
    'description',
    'teamId',
    'userId',
    'poolType',
    'amount',
    'artifactType',
    'artifactId',
    'occurredAt',
] as const;
export const SOW_USAGE_CSV_OPTIONAL_HEADERS = ['reason'] as const;

export const SOW_USAGE_CSV_TEMPLATE = `${[
    ...SOW_USAGE_CSV_REQUIRED_HEADERS,
    ...SOW_USAGE_CSV_OPTIONAL_HEADERS,
].join(',')}\n`;

export function buildSowUsageCsvTemplate(): string {
    return SOW_USAGE_CSV_TEMPLATE;
}

export function validateSowUsageCsvFile(file: File): string | null {
    if (!file.name.toLowerCase().endsWith('.csv')) {
        return 'Choose a file with a .csv extension.';
    }
    if (file.size === 0) {
        return 'Choose a non-empty CSV file.';
    }
    if (file.size > SOW_USAGE_CSV_MAX_BYTES) {
        return 'CSV files must be 1 MiB or smaller.';
    }
    return null;
}

export function downloadSowUsageCsvTemplate(): void {
    const blob = new Blob([buildSowUsageCsvTemplate()], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');

    try {
        anchor.href = url;
        anchor.download = 'sow_usage_import_template.csv';
        document.body.appendChild(anchor);
        anchor.click();
    } finally {
        anchor.remove();
        URL.revokeObjectURL(url);
    }
}
